exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sectionDetailComponent---284EP{margin:0 20px 20px}.standardTreeContainer---29SzC{margin:20px 0 0;height:600px;background-color:#fff}.spineNode .rst__rowContents{background-color:#dac292}.button---2Nl5F{margin-right:10px}", ""]);

// exports
exports.locals = {
	"sectionDetailComponent": "sectionDetailComponent---284EP",
	"standardTreeContainer": "standardTreeContainer---29SzC",
	"button": "button---2Nl5F"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader/dist/cjs.js?{"implementation":{"info":"dart-sass/t1.26.11/t(Sass Compiler)/t[Dart]/ndart2js/t2.9.3/t(Dart Compiler)/t[Dart]","types":{},"NULL":{},"TRUE":{"value":true},"FALSE":{"value":false}},"includePaths":["/usr/src/app/node_modules"]}!./app/components/section-detail/index.scss
// module id = 761
// module chunks = 3